import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { enumPaymentState } from '@data-layer/enums/payments';
import { BillModel } from '@data-layer/models/payments';
import { ICustomError } from '@shared/result/interfaces';

@Injectable({ providedIn: 'root' })
export class PaymentState {
  public successPayment$: BehaviorSubject<{ state: enumPaymentState; bill: BillModel }> = new BehaviorSubject<{
    state: enumPaymentState;
    bill: BillModel;
  }>(null);
  public pendingPayment$: BehaviorSubject<{ state: enumPaymentState; bill: BillModel }> = new BehaviorSubject<{
    state: enumPaymentState;
    bill: BillModel;
  }>(null);
  public errorCustomPayment$: BehaviorSubject<ICustomError> = new BehaviorSubject<ICustomError>(null);
  public errorCallback$: BehaviorSubject<ICustomError> = new BehaviorSubject<ICustomError>(null);
  public cancelCallback$: BehaviorSubject<ICustomError> = new BehaviorSubject<ICustomError>(null);
  public addToCard$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  constructor() {}

  public resetPaymentState(): void {
    this.successPayment$.next(null);
    this.pendingPayment$.next(null);
    this.errorCustomPayment$.next(null);
    this.errorCallback$.next(null);
    this.cancelCallback$.next(null);
    this.addToCard$.next(null);
  }
}
